( function( $ ) {

    $(document).ready(function(){
        setTimeout(function(){
            $('.nosmooth').removeClass('nosmooth');
        }, 500);
    });

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        // Дозволяємо лише цифри та "+"
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/

    /*custom scroll*/

    $(window).on("load",function(){

        $('.js-customScroll').mCustomScrollbar({
            callbacks:{
                onCreate:function(){
                    var rail = $(this).find('.mCSB_draggerRail');
                    var container = $(this).find('.mCSB_draggerContainer');
                    container.append(rail);
                }
            }
        });

        $('.js-customCatScroll').mCustomScrollbar({
            axis: "x",
            callbacks:{
                onCreate:function(){
                    var rail = $(this).find('.mCSB_draggerRail');
                    var container = $(this).find('.mCSB_draggerContainer');
                    container.append(rail);
                }
            }
        });

        $('.js-customBcScroll').mCustomScrollbar({
            axis: "x",
            callbacks:{
                onCreate:function(){
                    var rail = $(this).find('.mCSB_draggerRail');
                    var container = $(this).find('.mCSB_draggerContainer');
                    container.append(rail);
                }
            }
        });

    });
    /*custom scroll*/

    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header*/
    var hOffsetTop = 0;
    $(window).load(function(){
        if ($('.js-headerOffset').length > 0) {
            hOffsetTop = $('.js-header').offset().top;
        }
    });
    $(window).resize(function(){
        hOffsetTop = $('.js-header').offset().top;
    });
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight + hOffsetTop) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });

    $('.js-hMenu li.menu-item-has-children').hover(function(e){
        if ($(window).width() >= 1200) {
            if (e.type === 'mouseenter') {
                $(this).find('.sub-menu').fadeIn();
            } else if (e.type === 'mouseleave') {
                $(this).find('.sub-menu').fadeOut();
            }
        }
    })
    $('.js-hMenu .js-hMenuArr').click(function(e){
        if ($(window).width() < 1200) {
            $(this).closest('li.menu-item-has-children').toggleClass('active');
            $(this).siblings('.sub-menu').slideToggle();
        }
    })

    $('.js-hMenuBtn').click(function(){
        $('.js-modal').removeClass('active');
        $(this).toggleClass('active');
        $('.js-fixMenu').toggleClass('active');
        $('.js-sideModal').removeClass('active');
        $('.js-contModal').removeClass('active');
    });

    var hMenuSubs = null;
    $('.js-hMenuMain li.menu-item-has-children').hover(function(e){
        if ($(window).width() >= 1200) {
            if (e.type === 'mouseenter') {
                if (hMenuSubs !== null)
                    clearTimeout(hMenuSubs);
                
                $('.js-hMenuMain li.menu-item-has-children').removeClass('active');
                var clone = $(this).find('.sub-menu').first().clone();
                $(this).addClass('active');
                $('.js-fixMenuMainSubsTtl').text($(this).find('a').first().text());
                $('.js-fixMenuMainSubsMenu .sub-menu').remove()
                $('.js-fixMenuMainSubsMenu').append(clone)
                $('.js-fixMenuMainSubs').fadeIn();
            }
            else if (e.type === 'mouseleave') {
                hMenuSubs = setTimeout(function(){
                    hMenuSubFunc();
                }, 2000);
            }
        }
    });
    $('.js-fixMenuMainSubs').hover(function(e){
        if ($(window).width() >= 1200) {
            if (e.type === 'mouseenter') {
                if (hMenuSubs !== null)
                    clearTimeout(hMenuSubs);
            }
            else if (e.type === 'mouseleave') {
                hMenuSubs = setTimeout(function(){
                    hMenuSubFunc();
                }, 2000);
            }
        }
    });
    function hMenuSubFunc() {
        $('.js-hMenuMain li.menu-item-has-children').removeClass('active');
        $('.js-fixMenuMainSubsTtl').text('');
        $('.js-fixMenuMainSubsMenu .sub-menu').remove()
        $('.js-fixMenuMainSubs').fadeOut();
    }
    $('.js-hMenuMain .js-hMenuArr').click(function(e){
        if ($(window).width() < 1200) {
            if ($(window).width() > 767) {
                $('.js-hMenuMain li.menu-item-has-children').removeClass('active');
                var clone = $(this).siblings('.sub-menu').first().clone();
                $(this).closest('li.menu-item-has-children').addClass('active');
                $('.js-fixMenuMainSubsTtl').text($(this).siblings('a').first().text());
                $('.js-fixMenuMainSubsMenu .sub-menu').remove();
                $('.js-fixMenuMainSubsMenu').append(clone);
                $('.js-fixMenuMainSubs').fadeIn();
            } else {
                $(this).closest('li.menu-item-has-children').toggleClass('active');
                $(this).siblings('.sub-menu').slideToggle();
            }
        }
    })

    $('.js-sideModalBtn').click(function(){
        if (!$('.js-sideModal').hasClass('active')) {
            $('.js-modal').removeClass('active');
        }
        $('.js-hMenuBtn').removeClass('active');
        $('.js-fixMenu').removeClass('active');

        $('.js-sideModal').toggleClass('active')
    })
    $('.js-sideModalCls').click(function(){
        $('.js-sideModal').removeClass('active')
    })

    $('.js-contModalBtn').click(function(){
        if (!$('.js-contModal').hasClass('active')) {
            $('.js-modal').removeClass('active');
        }
        $('.js-hMenuBtn').removeClass('active');
        $('.js-fixMenu').removeClass('active');

        $('.js-contModal').toggleClass('active')
    })
    $('.js-contModalCls').click(function(){
        $('.js-contModal').removeClass('active')
    })


    $('.js-modalBtn').click(function(){
        if (!$('.js-modal#'+$(this).data('id')).hasClass('active')) {
            $('.js-modal').removeClass('active');
            $('.js-hMenuBtn').removeClass('active');
            $('.js-fixMenu').removeClass('active');
            $('.js-modal#'+$(this).data('id')).addClass('active')
        } else {
            $('.js-modal#'+$(this).data('id')).removeClass('active')
        }

    })
    $('.js-modalCls').click(function(){
        $(this).closest('.js-modal').removeClass('active')
    })

    /*header*/

    /*main*/

    /*video*/
    $(document).ready(function () {
        var iframe = $('#vimeo-player')[0];
        var player = new Vimeo.Player(iframe);
        player.getVolume().then(function (volume) {
            player.setVolume(0);
        });

        function toggleSound(_this) {
            player.getVolume().then(function (volume) {
                _this.find('.sound').removeClass('active');
                if (volume > 0) {
                    player.setVolume(0);
                    _this.find('.sound[data-sound="disabled"]').addClass('active');
                } else {
                    player.setVolume(1);
                    _this.find('.sound[data-sound="enabled"]').addClass('active');
                }
            });
        }

        $('.js-firstLoud').on('click', function () {
            toggleSound($(this));
        });
    });
    $('.js-mainFirstPlay').click(function(){
        $('#vimeo-player')[0].contentWindow.postMessage('{"method":"play"}', '*');
        $(this).remove();
    });
    /*video*/

    /*second*/
    $(document).ready(function(){
        var currentMousePos = { x: -1, y: -1 };
        $('.js-xRayZone').mousemove(function(e) {
            var skullOffsetTop = $('.js-xRayZone').offset();
            currentMousePos.x = e.pageX - skullOffsetTop.left;
            currentMousePos.y = e.pageY - skullOffsetTop.top;
          
          $('#skull').css('-webkit-mask-position-x', currentMousePos.x - 125);
          $('#skull').css('-webkit-mask-position-y', currentMousePos.y - 125)
        });
    });

    var mainSecPointSubs = null;
    $('.js-mainSecondPoint').hover(function(e){
        if ($(window).width() >= 992) {
            if (e.type === 'mouseenter') {
                if (mainSecPointSubs !== null)
                    clearTimeout(mainSecPointSubs);
                
                $('.js-mainSecondPointModal').fadeOut();
                $('.js-mainSecondPointModal[data-point="'+$(this).data('point')+'"]').fadeIn();
            }
            else if (e.type === 'mouseleave') {
                mainSecPointSubs = setTimeout(function(){
                    $('.js-mainSecondPointModal').fadeOut();
                }, 2000);
            }
        }
    });
    $('.js-mainSecondPointModal').hover(function(e){
        if ($(window).width() >= 992) {
            if (e.type === 'mouseenter') {
                if (mainSecPointSubs !== null)
                    clearTimeout(mainSecPointSubs);
            }
            else if (e.type === 'mouseleave') {
                mainSecPointSubs = setTimeout(function(){
                    $('.js-mainSecondPointModal').fadeOut();
                }, 2000);
            }
        }
    });
    $('.js-mainSecondPoint').click(function(){
        if ($(window).width() < 992) {
            document.querySelector("#traitements").scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    })
    $('.js-mainSecondItemTtl').click(function(){
        var active = $(this).hasClass('active');
        $('.js-mainSecondItemTtl').removeClass('active');
        $('.js-mainSecondItemCont').slideUp();
        if (!active) {
            $(this).addClass('active');
            $(this).siblings('.js-mainSecondItemCont').slideDown();
        }
    })

    $('.js-xRaySwitchBtn').click(function(){
        $(this).find('img').each(function(){
            if ($(this).hasClass('active')) {
                $(this).removeClass('active')
                $('.js-xRayPointsMobSwitch').removeClass('active')
            } else {
                $(this).addClass('active')
                $('.js-xRayPointsMobSwitch').addClass('active')
            }
        })
        $('.js-xRayMobSwitch').each(function(){
            if ($(this).hasClass('active')) {
                $(this).removeClass('active')
            } else {
                $(this).addClass('active')
            }
        })
    })
    /*second*/

    /*slider*/
    $(".js-mainSlider").on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
        var cnt = slick.options.slidesToScroll;
        var slideNum = (nextSlide === undefined) ? 1 : Math.ceil((nextSlide / slick.options.slidesToScroll) + 1);
        $(".js-mainSliderCount").html(
            '<span class="cur">' + slideNum + '</span>' + '<span class="sep"> - </span>' + '<span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
        );
    });
    $( '.js-mainSlider' ).each(function(){
        $(this).slick( {
            fade: false,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            draggable: false,
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 5000,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            appendArrows: $('.js-mainSliderArrows'),
            prevArrow: '<button class="arrow left prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5526)"> <path d="M17.1001 9H1.50024" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.00015 17.0999L0.900146 8.9999L9.00015 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5526"> <rect width="18" height="18" fill="white"/> </clipPath> </defs> </svg></button>',
            nextArrow: '<button class="arrow right next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5530)"> <path d="M0.900097 9H16.5" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.0001 17.0999L17.1001 8.9999L9.0001 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5530"> <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)"/> </clipPath> </defs> </svg></button>',

        } );
    })
    /*slider*/

    /*traits*/
    $(".js-mobMainTraitSlider").on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
        var cnt = slick.options.slidesToScroll;
        var slideNum = (nextSlide === undefined) ? 1 : Math.ceil((nextSlide / slick.options.slidesToScroll) + 1);
        $(".js-mobMainTraitSliderCount").html(
            '<span class="cur">' + slideNum + '</span>' + '<span class="sep"> - </span>' + '<span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
        );
    });
    $( '.js-mobMainTraitSlider' ).each(function(){
        $(this).slick( {
            fade: false,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            draggable: false,
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 5000,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            appendArrows: $('.js-mobMainTraitSliderArrows'),
            prevArrow: '<button class="arrow left prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5526)"> <path d="M17.1001 9H1.50024" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.00015 17.0999L0.900146 8.9999L9.00015 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5526"> <rect width="18" height="18" fill="white"/> </clipPath> </defs> </svg></button>',
            nextArrow: '<button class="arrow right next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5530)"> <path d="M0.900097 9H16.5" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.0001 17.0999L17.1001 8.9999L9.0001 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5530"> <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)"/> </clipPath> </defs> </svg></button>',

        } );
    })
    /*traits*/

    /*clin*/
    
    $( '.js-mainClinSlider' ).each(function(){
        $(this).slick( {
            fade: false,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            draggable: false,
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 5000,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            prevArrow: '<button class="arrow prev-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_2167_5132)"> <path d="M17.1001 9H1.50024" stroke="white" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.00015 17.0999L0.900146 8.9999L9.00015 0.899902" stroke="white" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5132"> <rect width="18" height="18" fill="white"/> </clipPath> </defs> </svg></button>',
            nextArrow: '<button class="arrow next-arrow"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_2167_5136)"> <path d="M0.900097 9H16.5" stroke="white" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.0001 17.0999L17.1001 8.9999L9.0001 0.899902" stroke="white" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5136"> <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)"/> </clipPath> </defs> </svg></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        } );
    })
    /*clin*/

    /*blog*/
    $(".js-mobMainBlogSlider").on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
        var cnt = slick.options.slidesToScroll;
        var slideNum = (nextSlide === undefined) ? 1 : Math.ceil((nextSlide / slick.options.slidesToScroll) + 1);
        $(".js-mobMainBlogSliderCount").html(
            '<span class="cur">' + slideNum + '</span>' + '<span class="sep"> - </span>' + '<span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
        );
    });
    $( '.js-mobMainBlogSlider' ).each(function(){
        $(this).slick( {
            fade: false,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            draggable: false,
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 5000,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            appendArrows: $('.js-mobMainBlogSliderArrows'),
            prevArrow: '<button class="arrow left prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g> <path d="M17.1001 9H1.50024" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.00015 17.0999L0.900146 8.9999L9.00015 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> </svg></button>',
            nextArrow: '<button class="arrow right next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g> <path d="M0.900097 9H16.5" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.0001 17.0999L17.1001 8.9999L9.0001 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> </svg></button>',

        } );
    })
    /*blog*/

    /*main*/

    /*page-clin*/
    $('.js-pageClinRevSlider').slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        prevArrow: '<button class="arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5526)"> <path d="M17.1001 9H1.50024" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.00015 17.0999L0.900146 8.9999L9.00015 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5526"> <rect width="18" height="18" fill="white"/> </clipPath> </defs> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5530)"> <path d="M0.900097 9H16.5" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.0001 17.0999L17.1001 8.9999L9.0001 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5530"> <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)"/> </clipPath> </defs> </svg></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    } );


    $('.js-pageClinSliderImgs').slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 2,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        prevArrow: '<button class="arrow prev-arrow"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.1 17.2L1 9.1L9.1 1" stroke="#DF6A38" stroke-linecap="square"/> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.1002 17.2L9.2002 9.1L1.1002 1" stroke="#DF6A38" stroke-linecap="square"/> </svg></button>',

    } );
    /*page-clin*/

    /*page-temo*/

    /*page-temo*/

    /*page-pat*/
    $( '.js-pagePatFichSlider' ).each(function(){
        var par = $(this).parent();
        $(this).on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
            var cnt = slick.options.slidesToScroll;
            var slideNum = (nextSlide === undefined) ? 1 : Math.ceil((nextSlide / slick.options.slidesToScroll) + 1);
            if (slick.options.slidesToShow < slick.slideCount) {
                par.find(".js-pagePatFichSliderCount").removeClass('d-none');
                par.find(".js-pagePatFichSliderCount").html(
                    '<span class="cur">' + slideNum + '</span>' + '<span class="sep"> - </span>' + '<span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
                );
            } else {
                par.find(".js-pagePatFichSliderCount").addClass('d-none');
            }
        });
        $(this).slick( {
            fade: false,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 700,
            slidesToShow: 2,
            slidesToScroll: 2,
            draggable: false,
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 5000,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            appendArrows: par.find('.js-pagePatFichSliderArrows'),
            prevArrow: '<button class="arrow left prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5526)"> <path d="M17.1001 9H1.50024" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.00015 17.0999L0.900146 8.9999L9.00015 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5526"> <rect width="18" height="18" fill="white"/> </clipPath> </defs> </svg></button>',
            nextArrow: '<button class="arrow right next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5530)"> <path d="M0.900097 9H16.5" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.0001 17.0999L17.1001 8.9999L9.0001 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5530"> <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)"/> </clipPath> </defs> </svg></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        } );
    })


    function initTopSlider() {
        if ($(window).width() <= 991) {
            $('.js-pagePatTopSlider').on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
                var cnt = slick.options.slidesToScroll;
                var slideNum = (nextSlide === undefined) ? 1 : Math.ceil((nextSlide / slick.options.slidesToScroll) + 1);
                $('.js-pagePatTopSlider').parent().find(".js-pagePatTopSliderCount").html(
                    '<span class="cur">' + slideNum + '</span>' + '<span class="sep"> - </span>' + '<span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
                );
            });
            if (!$('.js-pagePatTopSlider').hasClass('slick-initialized')) {
                $('.js-pagePatTopSlider').slick({
                    fade: false,
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 700,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: false,
                    variableWidth: false,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    pauseOnDotsHover: false,
                    appendArrows: $('.js-pagePatTopSlider').parent().find('.js-pagePatTopSliderArrows'),
                    prevArrow: '<button class="arrow left prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5526)"> <path d="M17.1001 9H1.50024" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.00015 17.0999L0.900146 8.9999L9.00015 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5526"> <rect width="18" height="18" fill="white"/> </clipPath> </defs> </svg></button>',
                    nextArrow: '<button class="arrow right next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5530)"> <path d="M0.900097 9H16.5" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.0001 17.0999L17.1001 8.9999L9.0001 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5530"> <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)"/> </clipPath> </defs> </svg></button>',
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        } else {
            if ($('.js-pagePatTopSlider').hasClass('slick-initialized')) {
                $('.js-pagePatTopSlider').slick('unslick');
            }
        }
    }

    $(document).ready(function() {
        initTopSlider();
    });
    $(window).resize(function() {
        initTopSlider();
    });

    function initDocsSlider() {
        if ($(window).width() <= 991) {
            $('.js-pagePatDocsSlider').on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
                var cnt = slick.options.slidesToScroll;
                var slideNum = (nextSlide === undefined) ? 1 : Math.ceil((nextSlide / slick.options.slidesToScroll) + 1);
                $('.js-pagePatDocsSlider').parent().find(".js-pagePatDocsSliderCount").html(
                    '<span class="cur">' + slideNum + '</span>' + '<span class="sep"> - </span>' + '<span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
                );
            });
            if (!$('.js-pagePatDocsSlider').hasClass('slick-initialized')) {
                $('.js-pagePatDocsSlider').slick({
                    fade: false,
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 700,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: false,
                    variableWidth: false,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    pauseOnDotsHover: false,
                    appendArrows: $('.js-pagePatDocsSlider').parent().find('.js-pagePatDocsSliderArrows'),
                    prevArrow: '<button class="arrow left prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5526)"> <path d="M17.1001 9H1.50024" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.00015 17.0999L0.900146 8.9999L9.00015 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5526"> <rect width="18" height="18" fill="white"/> </clipPath> </defs> </svg></button>',
                    nextArrow: '<button class="arrow right next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <g clip-path="url(#clip0_2167_5530)"> <path d="M0.900097 9H16.5" stroke="#DF6A38" stroke-linecap="square" stroke-linejoin="round"/> <path d="M9.0001 17.0999L17.1001 8.9999L9.0001 0.899902" stroke="#DF6A38" stroke-linecap="square"/> </g> <defs> <clipPath id="clip0_2167_5530"> <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)"/> </clipPath> </defs> </svg></button>',
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        } else {
            if ($('.js-pagePatDocsSlider').hasClass('slick-initialized')) {
                $('.js-pagePatDocsSlider').slick('unslick');
            }
        }
    }

    $(document).ready(function() {
        initDocsSlider();
    });
    $(window).resize(function() {
        initDocsSlider();
    });
    /*page-pat*/

    /*single parcours*/
    $('.js-sParcQuest').click(function(){
        $(this).toggleClass('active');
        $(this).siblings('.js-sParcQuestTxt').slideToggle();
    })
    /*single parcours*/

    /*page tarifs*/
    $('.js-pageTarifsTblBtn').click(function(){
        if (!$(this).hasClass('active')) {
            $('.js-pageTarifsTblBtn').removeClass('active');
            $('.js-pageTarifsTbl').removeClass('active');
            $(this).addClass('active');
            $('.js-pageTarifsTbl[data-tarif="'+$(this).data('tarif')+'"]').addClass('active');
        }
    })
    /*page tarifs*/


    /*float placeholders*/
    $('body').click(function(){
        $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').each(function(el){
            if ($(this).val() === '')
                $(this).closest('.js-formItem').removeClass('floated');

        });
    })
    $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').click(function(){
        var _this = $(this);
        setTimeout(function(){
            $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').each(function(el){
                if ($(this).val() === '')
                    $(this).closest('.js-formItem').removeClass('floated');

            });
            _this.closest('.js-formItem').addClass('floated');
        }, 5)
    })
    /*float placeholders*/

    /*blog pagi*/
    if (typeof ajax_blog_pagi !== 'undefined' && ajax_blog_pagi === true) {
        $('.js-blogPagiCat').click(function() {
            var prev_pag = paged;
            var prev_cat = pages_categ;

            paged = 1;
            pages_categ = $(this).data('slug');

            ajax_blog_pagi_func(prev_pag, $(this), prev_cat);
        });
        $('.js-blogPagiBtn').click(function() {
            var prev_pag = paged;
            var type = $(this).data('type');
            if (type === 'prev') {
                paged--;
            } else {
                paged++;
            }
            ajax_blog_pagi_func(prev_pag);
        });

        function ajax_blog_pagi_func(prev_pag = 1, cat_obj = null, prev_cat = null) {
            $('.js-blogPagiBtn').addClass('inactive')
            $('.js-blogPagiCat').addClass('inactive')
            $('.js-blogPagiPreloader').addClass('active')
            $.ajax({
                url: ajax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'blog_pagi_action',
                    paged: paged,
                    tax: pages_categ,
                    post_per_page: post_per_page
                },
                success: function(response) {
                    var resp = JSON.parse(response);
                    pages_count = resp.pages_count;

                    $('.js-blogPagiBtn').removeClass('inactive')
                    $('.js-blogPagiCat').removeClass('inactive')
                    $('.js-blogPagiPreloader').removeClass('active')
                    if (paged >= pages_count) {
                        $('.js-blogPagiBtn[data-type="next"]').addClass('inactive')
                    }
                    if (paged <= 1) {
                        $('.js-blogPagiBtn[data-type="prev"]').addClass('inactive')
                    }
                    if (cat_obj !== null) {
                        $('.js-blogPagiCat').removeClass('active');
                        cat_obj.addClass('active');
                    }
                    $('.js-blogPagi').html(resp.html);
                    ajax_blog_pagi_pages_reset_func(resp.pages_count);
                },
                error: function(xhr, status, error) {
                    $('.js-blogPagiBtn').removeClass('inactive')
                    $('.js-blogPagiCat').removeClass('inactive')
                    $('.js-blogPagiPreloader').removeClass('active')
                    paged = prev_pag;
                    if (prev_cat !== null) {
                        pages_categ = prev_cat;
                    }
                    console.error(error)
                }
            });
        }

        function ajax_blog_pagi_pages_reset_func(pages_count) {
            if (pages_count <= 1) {
                $('.js-blogPagiWrap').addClass('hidden');
            } else {
                $('.js-blogPagiWrap').removeClass('hidden');
            }
            $('.js-blogPagiPages').html('<span class="cur">' + paged + '</span><span class="sep">-</span><span class="all">' + pages_count + '</span>')
        }
    }
    /*blog pagi*/

}( jQuery ) );
